import { FileExtensions } from 'types/fileExtensions';

export enum LogoExtensions {
  // biome-ignore lint/style/useLiteralEnumMembers: <explanation>
  PNG = FileExtensions.PNG,
  // biome-ignore lint/style/useLiteralEnumMembers: <explanation>
  SVG = FileExtensions.SVG,
}

export enum DefaultLogos {
  main = 'main',
  timer = 'timer',
}

export interface LogoInterface {
  key: string;
  supportedExtensions: Array<LogoExtensions>;
  defaultSrc: string;
  setSupportedExtensions: (extensions: Array<LogoExtensions>) => void;
  getSupportedExtensions: () => Array<LogoExtensions>;
  setKey: (key: string) => void;
  getKey: () => string;
  setDefaultSrc: (defaultModel: string) => void;
  getDefault: () => string;
}

class Logo implements LogoInterface {
  public key = '';
  public supportedExtensions: Array<LogoExtensions> = [];
  public defaultSrc = '';

  constructor(key: string, supportedExtensions: Array<LogoExtensions>, defaultSrc: string) {
    this.setKey(key);
    this.setSupportedExtensions(supportedExtensions);
    this.setDefaultSrc(defaultSrc);
  }

  setDefaultSrc(defaultSrc: string) {
    this.defaultSrc = defaultSrc;
  }
  getDefault() {
    return this.defaultSrc;
  }

  setSupportedExtensions(supportedExtensions: Array<LogoExtensions>) {
    this.supportedExtensions = supportedExtensions;
  }

  getSupportedExtensions() {
    return this.supportedExtensions;
  }

  setKey(key: string) {
    this.key = key;
  }

  getKey() {
    return this.key;
  }
}

export const getLogoModel = (
  key: string,
  supportedExtensions: Array<LogoExtensions> | [],
  defaultLogoSrc: string,
) => {
  return new Logo(key, supportedExtensions, defaultLogoSrc);
};

export const getDefaultLogo = (defaultLogoSrc: string) => {
  return getLogoModel(DEFAULTLOGOKEY, NOCUSTOMLOGO, defaultLogoSrc);
};

export const STANDARDLOGOKEY = 'standard';
export const DEFAULTLOGOKEY = 'default';

export const ALLEXTENSIONS = [LogoExtensions.SVG];
export const NOCUSTOMLOGO = [];
